import styles from "./LiveBadge.module.css"

const LiveBadge = ({style, label}) => {

    return (
        <div className={styles.container} style={style}>
            <div className={styles.onair}></div>
            {label ? label : 'LIVE'}
        </div>
    )
}

export default LiveBadge